export default __webpack_public_path__ + "static/media/PinnacleHire.bc18ae0d.png";